import {Component} from '@angular/core';
import {TabsetComponent} from '../../common/component/tabset/tabset.component';
import {TabComponent} from '../../common/component/tabset/tab/tab.component';

import {PlanModelService} from '../../common/service/plan-model.service';
import {PlanLodgementService} from '../../common/service/plan-lodgement.service';
import {PDF_CREATION_METHOD, PDF_CREATION_METHOD_DESCRIPTION, PLAN_LODGEMENT_STAGE_DESCRIPTION} from '../../common/constants';
import {ValidationResultsComponent} from '../../validation-results/validation-results.component';
import {NlrHasPermissionsPipe} from '../../common/pipe/nlr-has-permissions.pipe';
import {AlertModalService} from '../../common/component/modal';
import {PermissionsService} from '../../common/service/permissions.service';
import {NLR_TABS as TABS} from '../../common/constants';


@Component({
    selector: 'nlr-left',
    imports: [TabsetComponent, TabComponent, ValidationResultsComponent, NlrHasPermissionsPipe],
    templateUrl: './left.component.html',
    styleUrl: './left.component.scss'
})
export class LeftComponent {
    TABS = TABS;

    protected readonly PDF_CREATION_METHOD = PDF_CREATION_METHOD;

    propIsAnalysisTabEnabled: boolean = undefined;
    propIsDesignTabEnabled: boolean = undefined;
    propIsInterestsTabEnabled: boolean = undefined;
    propIsCertificationTabEnabled: boolean = undefined;

    constructor(
        private alertModalService: AlertModalService,
        private planModelService: PlanModelService,
        private planLodgementService: PlanLodgementService,
        private permissionsService: PermissionsService
    ) {
        this.preventAnalysisTabSelection = this.preventAnalysisTabSelection.bind(this);
    }

    isAnalysisTabEnabled() {
        this.propIsAnalysisTabEnabled = this.planLodgementService.analysisApplicable();
        return this.propIsAnalysisTabEnabled;
    }

    preventAnalysisTabSelection() {
        if (
            this.getModel().strataPlanActions.length === 0 &&
            !this.getModel().dependantPlans.some(dp => ['DESCENDANT', 'FORMER_TENURE', 'SPATIAL'].includes(dp.dependencyType))
        ) {
            this.alertModalService.createAlertMessage('No dependent plans that require your consideration detected', 'OK', 'Dependencies', 'info');
            return true;
        }
        return false;
    }

    isDesignTabEnabled() {
        this.propIsDesignTabEnabled = this.planLodgementService.designApplicable();
        return this.propIsDesignTabEnabled;
    }

    isDigitalPlanTabEnabled() {
        return this.planModelService.getModel().pdfCreationMethod === PDF_CREATION_METHOD.DIGITAL_PLAN;
    }

    isInterestsTabEnabled() {
        this.propIsInterestsTabEnabled = this.planLodgementService.interestsApplicable();
        return this.planLodgementService.interestsApplicable();
    }

    isCertificationTabEnabled() {
        this.propIsCertificationTabEnabled = this.planLodgementService.certificationApplicable();
        return this.planLodgementService.certificationApplicable();
    }

    isAdditionalsTabEnabled() {
        return false;
    }

    isLodgeTabEnabled() {
        return true;
    }

    getLodgementStageDescription(planLodgementStage: string) {
        return PLAN_LODGEMENT_STAGE_DESCRIPTION[planLodgementStage] ?? '';
    }

    getPdfCreationMethodDescription(pdfCreationMethod: string) {
        return pdfCreationMethod;
    }

    getModel() {
        return this.planModelService.getModel();
    }

    hasAdditionalsPermission() {
        return this.permissionsService.getPermissions(['EDIT_ADDITIONALS', 'VIEW_ADDITIONALS']).length > 0;
    }

    protected readonly PDF_CREATION_METHOD_DESCRIPTION = PDF_CREATION_METHOD_DESCRIPTION;
}
